import { render } from "./CreatePrescripcionEstudios.vue?vue&type=template&id=0522f9bf&scoped=true"
import script from "./CreatePrescripcionEstudios.vue?vue&type=script&lang=js"
export * from "./CreatePrescripcionEstudios.vue?vue&type=script&lang=js"

import "./CreatePrescripcionEstudios.vue?vue&type=style&index=0&id=0522f9bf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0522f9bf"]])

export default __exports__